import React from 'react';
const stats = [{
  value: '6',
  label: 'Professional Modules'
}, {
  value: '250+',
  label: 'Exercises'
}, {
  value: '100',
  label: 'Ready-to-Use Sessions'
}, {
  value: '12 Months',
  label: 'Of Programming'
}];
export function StatsBar() {
  return <section className="bg-petrol text-white px-4 sm:px-6 py-6 sm:py-8" data-id="element-163" data-mp="1odhyz6z2q33e">
      <div className="max-w-4xl mx-auto" data-id="element-164" data-mp="1jbiws0f2lc81">
        <h2 className="text-center font-heading font-bold text-[10px] sm:text-xs uppercase tracking-[0.14em] text-white/60 mb-5 leading-relaxed" data-id="element-165" data-mp="1ed7j1elnmhkj">
          Built for senior fitness professionals who are done starting from zero
        </h2>

        <dl className="grid grid-cols-2 lg:grid-cols-4 gap-y-4 gap-x-3" data-id="element-166" data-mp="15lyv6xx86l0b">
          {stats.map(stat => <div key={stat.label} className="text-center lg:border-r lg:border-white/10 lg:last:border-r-0" data-id="element-167" data-mp="10n42935jng2h">
              <dt className="sr-only" data-id="element-168" data-mp="qnmxcny4967k">{stat.label}</dt>
              <dd data-id="element-169" data-mp="qo6jkgusugre">
                <span className="block font-heading font-black text-xl sm:text-3xl text-lime leading-none mb-1" data-id="element-170" data-mp="qppzg6cjmpsn">
                  {stat.value}
                </span>
                <span className="block font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.12em] text-white/70 leading-snug" data-id="element-171" data-mp="3tflz10h9zt2v">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}